module.exports = __webpack_public_path__ + "static/img/logo.091953b7.png";